import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosInstance from "../../helpers/axiosInstance";

const initialState = {
    loading: false,
    status: false,
    userData: null,
};

export const getForm = createAsyncThunk("getForm", async (data) => {
    try {
        const response = await axiosInstance.post("/form/get_form", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const saveForm = createAsyncThunk("saveForm", async (data) => {
    try {
        const response = await axiosInstance.post("/form/save_form", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const deleteForm = createAsyncThunk("deleteForm", async (data) => {
    try {
        const response = await axiosInstance.post("/form/delete_form", data);
        return response.data;
    } catch (error) {
        throw new Error(error.response.data.message || 'Something went wrong');
    }
});

export const formSlice = createSlice({
    name: "auth",
    initialState,
    reducers: {
        clearState: (state) => {
            state.loading = false;
            state.status = false;
            state.userData = null;
        },
    },
    extraReducers: (builder) => {
        builder.addCase(getForm.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(getForm.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });
        builder.addCase(getForm.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(saveForm.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(saveForm.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });
        builder.addCase(saveForm.rejected, (state) => {
            state.loading = false;
        });

        builder.addCase(deleteForm.pending, (state) => {
            state.loading = true;
        });
        builder.addCase(deleteForm.fulfilled, (state, action) => {
            state.loading = false;
            state.status = true;
            state.userData = action.payload;
        });
        builder.addCase(deleteForm.rejected, (state) => {
            state.loading = false;
        });
    },
});

export default formSlice.reducer;
